exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_trackinCodeTitle__2wche {\n  color: var(--f7-list-item-text-text-color);\n  font-weight: normal;\n  font-size: small;\n}\n\n.styles_trackingCodeText__2gDWr {\n  letter-spacing: .2rem;\n}\n\n.styles_orderContentItem__Wgz0O {\n  margin-top: .5rem;\n}\n\n.styles_orderContentItem__Wgz0O .styles_priceBox__1w_NY {\n  text-align: left;\n  font-weight: bold;\n  font-size: larger;\n}", ""]);

// Exports
exports.locals = {
	"trackinCodeTitle": "styles_trackinCodeTitle__2wche",
	"trackingCodeText": "styles_trackingCodeText__2gDWr",
	"orderContentItem": "styles_orderContentItem__Wgz0O",
	"priceBox": "styles_priceBox__1w_NY"
};